const existCancelledAccounts = (immAccounts) => {
    const immAccountsByOrder = immAccounts.get('byOrder');
    const immAccountsById = immAccounts.get('byId');

    return immAccountsByOrder.filter((accountId) => {
        return immAccountsById.get(accountId).getIn(['filters', 'canceled']);
    }).size > 0;
}

module.exports = {
    existCancelledAccounts
}